(() => {
  if (customElements.get('mr-weekly-edit')) return;
  class WeeklyEdit extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const {signal} = this.events;
      this.track = this.querySelector('[data-edit-track]');
      this.slides = [...this.querySelectorAll('[data-edit-slide]')];
      this.section = this.querySelector('.mr-weekly-edit');
      this.previous = this.querySelector('[data-edit-prev]');
      this.next = this.querySelector('[data-edit-next]');
      this.index = 0;
      this.previous?.addEventListener('click', () => this.go(this.index - 1), {signal});
      this.next?.addEventListener('click', () => this.go(this.index + 1), {signal});
      this.track?.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      }, {passive:true, signal});
      this.track?.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const keys = {ArrowLeft:this.index-1, ArrowRight:this.index+1, Home:0, End:this.slides.length-1};
        if (event.key in keys) {event.preventDefault();this.go(keys[event.key]);}
      }, {signal});
      this.querySelectorAll('[data-edit-open]').forEach(button => button.addEventListener('click', () => {
        const dialog = this.querySelector(`[data-edit-dialog="${button.dataset.editOpen}"]`);
        if (!dialog) return;
        this.returnFocus = button;
        dialog.showModal();
      }, {signal}));
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.querySelector('[data-edit-close]')?.addEventListener('click',()=>dialog.close(),{signal});
        dialog.addEventListener('click',event=>{
          const rect=dialog.getBoundingClientRect();
          if(event.target===dialog&&(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom))dialog.close();
        },{signal});
        dialog.addEventListener('close',()=>this.returnFocus?.focus({preventScroll:true}),{signal});
      });
      this.sizeObserver = new ResizeObserver(()=>this.sync());
      if(this.track)this.sizeObserver.observe(this.track);
      document.addEventListener('shopify:block:select',event=>{
        const slide=event.target.closest('[data-edit-slide]');
        if(slide&&this.contains(slide))this.go(this.slides.indexOf(slide),true);
      },{signal});
      this.sync();
    }
    motionAllowed(){return this.dataset.motion!=='false'&&!matchMedia('(prefers-reduced-motion: reduce)').matches;}
    go(index,immediate=false){
      if(!this.track||!this.slides.length)return;
      index=Math.max(0,Math.min(index,this.slides.length-1));
      const offset=this.slides[index].offsetLeft-this.slides[0].offsetLeft;
      this.track.scrollTo({left:Math.min(offset,this.track.scrollWidth-this.track.clientWidth),behavior:immediate||!this.motionAllowed()?'instant':'smooth'});
    }
    sync(){
      if(!this.track||!this.slides.length)return;
      const left=this.track.scrollLeft,max=this.track.scrollWidth-this.track.clientWidth,first=this.slides[0].offsetLeft;
      this.index=this.slides.reduce((best,slide,index)=>Math.abs(Math.min(slide.offsetLeft-first,max)-left)<Math.abs(Math.min(this.slides[best].offsetLeft-first,max)-left)?index:best,0);
      if(this.previous)this.previous.disabled=this.index===0;
      if(this.next)this.next.disabled=this.index===this.slides.length-1;
      this.querySelectorAll('[data-edit-dot]').forEach((dot,index)=>dot.classList.toggle('is-current',index===this.index));
      const count=this.querySelector('[data-edit-count]');
      if(count)count.textContent=`${this.index+1} / ${this.slides.length}`;
      const controls=this.querySelector('[data-edit-controls]');
      if(controls)controls.hidden=this.slides.length<2;
      this.section?.classList.toggle('mr-weekly-edit--single',this.slides.length<2);
    }
    disconnectedCallback(){
      this.events?.abort();this.events=null;
      this.sizeObserver?.disconnect();cancelAnimationFrame(this.frame);
      this.querySelectorAll('dialog[open]').forEach(dialog=>dialog.close());
    }
  }
  customElements.define('mr-weekly-edit',WeeklyEdit);
})();
